import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_NATIVE_DATE_FORMATS,
  MatNativeDateModule,
  NativeDateAdapter
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ImageUploadService } from '../../../services/uploadImage.service';
import { assets } from '../../../core/constants/assets.const';
import { Document } from '../../../models/documents.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'xplora-website-upload-document',
  standalone: true,
  templateUrl: './upload-document.component.html',
  styleUrl: './upload-document.component.scss',
  providers: [
    { provide: DateAdapter,
      useClass: NativeDateAdapter },
    { provide: MAT_DATE_FORMATS,
      useValue: MAT_NATIVE_DATE_FORMATS }
  ],
  imports: [
    MatIconModule,
    MatDialogModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    CommonModule,
    TranslateModule
  ]
})
export class UploadDocumentComponent implements OnInit {
  protected uploadFormGroup: FormGroup;
  protected submitted: boolean = false;
  protected assetsConst = assets;
  protected today: Date = new Date();
  protected tomorrow: Date = new Date();
  protected yesterday: Date = new Date();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Document[],
    private formBuilder: FormBuilder,
    private _uploadImageService: ImageUploadService,
    private MatDialogRef: MatDialogRef<UploadDocumentComponent>
  ) {
    this.uploadFormGroup = this.formBuilder.group({
      documents: new FormArray([])
    });

    this.handleDocuments(data);
  }

  ngOnInit(): void {

    this.tomorrow.setDate(this.today.getDate() + 1);
    this.yesterday.setDate(this.today.getDate());
  }

  get getDocuments(): FormArray {
    return <FormArray> this.uploadFormGroup.get('documents');
  }

  handleDocuments(data: Array<Document>): void {
    for (const item of data) {
      this.getDocuments.push(this.addDocumentsToGroup(item));
    }
  }

  addDocumentsToGroup(data: Document): AbstractControl {
    return this.formBuilder.group({
      name: [data.name],
      frontImage: [
        data.frontImage ? data.frontImage : '',
        data.frontImageRequire ? Validators.required : null
      ],
      frontImageRequire: [data.frontImageRequire],
      backImage: [
        data.backImage ? data.backImage : '',
        data.backImageRequire ? Validators.required : null
      ],
      backImageRequire: [data.backImageRequire],
      issueDate: [
        data.issueDate ? data.issueDate : '',
        data.issueDateRequire ? Validators.required : null
      ],
      issueDateRequire: [data.issueDateRequire],
      expiryDate: [
        data.expiryDate ? data.expiryDate : '',
        data.expiryDateRequire ? Validators.required : null
      ],
      expiryDateRequire: [data.expiryDateRequire],
      docType: [data._id]
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ondynamicDocsImageChange(event: any, i: number, control: string): void {
    this._uploadImageService
      .onFileChange(event)
      .then((res: { data: { image: string } }) => {
        this.getDocuments.controls[i]?.patchValue({
          [control]: res['data']['image']
        });
      });
  }

  close(): void {
    this.MatDialogRef.close(false);
  }

  onSubmit = (): void => {
    this.submitted = true;
    if (this.uploadFormGroup.valid) {
      this.MatDialogRef.close(this.uploadFormGroup.value);
    }
  };
}
